module.exports = __webpack_public_path__ + "img/facial-treatment.af58b285.png";